import React from "react"
import PropTypes from "prop-types"
import { defineMessages } from "react-intl"
import MUIDataTable from "mui-datatables"
import { saveAs } from "file-saver"
import { write, utils } from "xlsx"
import GetAppIcon from "@material-ui/icons/GetApp"
import CloudDownloadIcon from "@material-ui/icons/CloudDownload"
import TooltipIconButton from "../buttons/TooltipIconButton"
import dataTableMessages from "../../i18n/lstrings"

const messages = defineMessages({
  downloadExcel: {
    defaultMessage: "Download Excel",
    id: "datatable.toolbar.download.excel"
  }
})

/**
 * This component is used to handle custom Download options for MUI Datatables
 * We want to have CSV export and Excel export next to each other on the same line
 *
 * This Table options still have priority over the new default custom toolbar
 * */
const DataTable = (props) => {
  const { data, options } = props
  const { download } = options

  const downloadXlsx = () => {
    const ws = utils.json_to_sheet(data)
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] }
    const excelBuffer = write(wb, { bookType: "xlsx", type: "array" })
    saveAs(new Blob([excelBuffer]), "table.xlsx")
  }

  const downloadCsv = () => {
    const ws = utils.json_to_sheet(data)
    const csv = utils.sheet_to_csv(ws)
    saveAs(new Blob([csv]), "table.csv")
  }

  let { customToolbar } = options

  if (download) {
    // eslint-disable-next-line react/display-name
    customToolbar = () => (
      <>
        {(download === true ||
          (Array.isArray(download) && download?.includes("csv"))) && (
          <TooltipIconButton
            onClick={downloadCsv}
            label={dataTableMessages.toolbarDownloadCsv}
          >
            <CloudDownloadIcon />
          </TooltipIconButton>
        )}
        {(download === true ||
          (Array.isArray(download) && download?.includes("xlsx"))) && (
          <TooltipIconButton
            onClick={downloadXlsx}
            label={messages.downloadExcel}
          >
            <GetAppIcon />
          </TooltipIconButton>
        )}
        {options.customToolbar?.()}
      </>
    )
  }

  return (
    <MUIDataTable
      {...props}
      options={{
        ...options,
        elevation: 0, // GAM style
        download: false,
        customToolbar
      }}
    />
  )
}

DataTable.propTypes = {
  data: PropTypes.any.isRequired,
  options: PropTypes.object
}

DataTable.defaultProps = {
  options: undefined
}

export default DataTable
